export default "__VITE_ASSET__CBjiJkMg__"